import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import ComboBoxMui from 'components/ComboBox/comboBox.mui'
import HighlightedText from 'components/ComboBox/HighlightedText'
import { AdvancedComboBoxProps, ComboBoxOptionOption } from 'components/ComboBox/types'

export default function AdvancedComboBoxMui<T>( { getSecondaryText, ...props }: AdvancedComboBoxProps<T> ) {
	const renderSecondaryText = ( text: string | string[], searchValue: string ) => {
		if ( typeof text === 'string' ) {
			return <HighlightedText text={text} search={searchValue} />
		}

		return (
			<Stack direction="row" justifyContent="space-between" spacing={1}>
				{text.map( ( t, i ) => (
					<Typography key={`text-item-${i}`} component="span" variant="caption">
						<HighlightedText text={t} search={searchValue} />
					</Typography>
				) )}
			</Stack>
		)
	}

	const renderComboBoxOption = ( option: ComboBoxOptionOption<T>, searchValue: string ) => {
		if ( !option.value ) {
			return null
		}

		return (
			<Stack width="100%">
				<Typography component="span" variant="body2">
					<HighlightedText text={props.getName( option.value )} search={searchValue} />
				</Typography>
				<Typography component="span" variant="caption" color="text.secondary">
					{renderSecondaryText( getSecondaryText( option.value ), searchValue )}
				</Typography>
			</Stack>
		)
	}

	return (
		<ComboBoxMui
			{...props}
			renderOption={renderComboBoxOption}
		/>
	)
}
